import { createSlice } from '@reduxjs/toolkit'

// The enroll step machine + form state live in the screen component (mirroring the
// source EnrollCardModalPage); this slice only holds the server-fetched bootstrap
// (eligibility, shippable addresses, cards, user, treatments) loaded once on mount.

export interface BdmcEnrollEligibility {
  isEligible?: boolean
  details?: {
    accountTypeInvalid?: boolean
    upgradeRequired?: boolean
    similarProductExists?: boolean
    addressInvalid?: boolean
    invalidStateRestricted?: boolean
    countryUnsupported?: boolean
  }
}

export interface BdmcEnrollBootstrap {
  primaryEligibility: BdmcEnrollEligibility | null
  additionalEligibility: BdmcEnrollEligibility | null
  shippableAddresses: any[]
  cards: any[]
  user: { firstName?: string; country?: string }
  enableInstantCard: boolean
  clientMetadataId: string | null
  isUserPartOfCustomerList?: boolean
  applicationAlreadyApproved?: boolean
  secondaryUser?: boolean
}

interface BdmcEnrollState {
  bootstrap: BdmcEnrollBootstrap | null
  isLoading: boolean
  error: string | null
}

const initialState: BdmcEnrollState = {
  bootstrap: null,
  isLoading: false,
  error: null,
}

const bdmcEnrollSlice = createSlice({
  name: 'bdmcEnroll',
  initialState,
  reducers: {
    bootstrapFetchStart(state) {
      state.isLoading = true
      state.error = null
    },
    bootstrapFetchSuccess(state, action) {
      state.bootstrap = action.payload
      state.isLoading = false
    },
    bootstrapFetchFailure(state, action) {
      state.error = action.payload
      state.isLoading = false
    },
    reset() {
      return { ...initialState }
    },
  },
})

export const selectBdmcEnrollBootstrap = (state: any): BdmcEnrollBootstrap | null =>
  state.bdmcEnroll.bootstrap
export const selectBdmcEnrollIsLoading = (state: any): boolean => state.bdmcEnroll.isLoading
export const selectBdmcEnrollError = (state: any): string | null => state.bdmcEnroll.error

export const { bootstrapFetchStart, bootstrapFetchSuccess, bootstrapFetchFailure, reset } =
  bdmcEnrollSlice.actions

export default bdmcEnrollSlice.reducer
